<template>
  <v-slide-x-transition>
    <v-select
      v-if="show"
      v-model="selectedFeature"
      clearable
      hide-details
      :items="features"
      label="Atributo"
      :loading="loadingFeatures"
    >
      <!-- How the items are displayed in the list -->
      <template #item="{ item }">
        <span :class="['feature-span', item.color]">{{ item.name }}</span>
      </template>
      <!-- How the selected item is displayed -->
      <template #selection="{ item }">
        <span :class="['feature-span', item.color]">{{ item.name }}</span>
      </template>
    </v-select>
  </v-slide-x-transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  computed: {
    ...mapState("ner", [
      "classification",
      "features",
      "loadingFeatures",
      "products"
    ]),
    selectedFeature: {
      get() {
        return this.$store.state.ner.selectedFeature;
      },
      set(value) {
        this.setSelectedFeature(value);
      }
    },
    show() {
      return !!this.classification && this.products.length;
    }
  },
  methods: {
    ...mapMutations("ner", ["setSelectedFeature"])
  }
};
</script>

<style scoped>
.feature-span {
  padding: 3px 5px;
  border-radius: 5px;
}
</style>